import { Pipe, PipeTransform } from '@angular/core';
//import { OrderEventType } from '../models/models';

@Pipe({
    name: 'orderEventType',
    pure: false,
    standalone: false
})

export class OrderEventTypePipe implements PipeTransform {
    transform(items: any[], filter: string): any {
        if (!items || !filter) {
            return items;
        }

        return items.filter(item => item.code.indexOf(filter) !== -1);
    }
}
